export const detectWebView = () => {
  if (typeof window === 'undefined') return false
  if (window.ReactNativeWebView) return true

  const ua = navigator.userAgent || ''
  const isAndroidWebView = /\bwv\b/.test(ua) || /Android.*Version\/\d+\.\d+/.test(ua)
  const isiOS = /iP(ad|hone|od)/.test(ua)
  const isWebKit = /AppleWebKit/.test(ua)
  const isSafari = /Safari/.test(ua)
  const isiOSWebView = isiOS && isWebKit && !isSafari

  return isAndroidWebView || isiOSWebView
}

export const detectWebViewSource = () => {
  if (typeof window === 'undefined') return 'unknown'
  if (window.ReactNativeWebView) return 'react-native'

  const ua = navigator.userAgent || ''
  if (/\bwv\b/.test(ua) || /Android.*Version\/\d+\.\d+/.test(ua)) return 'android-ua'
  if (/iP(ad|hone|od)/.test(ua) && /AppleWebKit/.test(ua) && !/Safari/.test(ua)) return 'ios-ua'

  return 'unknown'
}
